import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    faCloud,
    faCloudDownloadAlt,
    faCloudUploadAlt,
    faFilePdf,
    faLock,
    faLockOpen,
    faMinusCircle,
    faPencilAlt,
    faSyncAlt,
} from '@fortawesome/free-solid-svg-icons';
import { faCircle, faDotCircle } from '@fortawesome/free-regular-svg-icons';
import { FormListEntryState } from '../../../types/form-list';
import { FormsConstants } from '../../../types/forms-constants';
import SUBMIT_STATUS = FormsConstants.SUBMIT_STATUS;

@Component({
    selector: 'pace-forms-list-entry',
    templateUrl: './forms-list-entry.component.html',
    styleUrls: ['./forms-list-entry.component.scss'],
    standalone: false,
})
export class FormsListEntryComponent {
    @Input()
    public entry: FormListEntryState;

    @Input()
    public showAbortFormButton = false;

    @Input()
    public showDocumentationLink = false;

    @Input()
    public showRefreshXMLButton = false;

    @Input()
    public userFrontId: string;

    @Output()
    public previewForm = new EventEmitter();

    @Output()
    public abortForm = new EventEmitter();

    @Output()
    public openInstructions = new EventEmitter();

    @Output()
    public refreshXML = new EventEmitter();

    @Output()
    public editForm = new EventEmitter();

    protected readonly faMinusCircle = faMinusCircle;
    protected readonly faFilePdf = faFilePdf;
    protected readonly faLock = faLock;
    protected readonly faCloud = faCloud;
    protected readonly faDotCircle = faDotCircle;
    protected readonly faSyncAlt = faSyncAlt;
    protected readonly faCircle = faCircle;
    protected readonly faCloudUpload = faCloudUploadAlt;
    protected readonly faUnlock = faLockOpen;
    protected readonly faCloudDownload = faCloudDownloadAlt;
    protected readonly faPencil = faPencilAlt;

    public hasBeenLoadedFromInterim(entry: FormListEntryState): boolean {
        return entry.loadStatus === FormsConstants.LOAD_STATUS.INTERIM;
    }

    public hasBeenLoadedFromTemplate(entry: FormListEntryState): boolean {
        return entry.loadStatus === FormsConstants.LOAD_STATUS.TEMPLATE;
    }

    public hasBeenUploaded(entry: FormListEntryState): boolean {
        return [
            SUBMIT_STATUS.FINAL,
            SUBMIT_STATUS.FINAL_NOT_OK,
            SUBMIT_STATUS.INTERIM,
            SUBMIT_STATUS.INTERIM_NOT_OK,
            SUBMIT_STATUS.HANDOVER,
        ].includes(entry.submitStatus);
    }

    public disableAbortButton(entry: FormListEntryState): boolean {
        const hasLock = this.userFrontId === entry.lockedBy;

        const hasBeenSubmitted = [
            SUBMIT_STATUS.HANDOVER,
            SUBMIT_STATUS.INTERIM,
            SUBMIT_STATUS.INTERIM_NOT_OK,
            SUBMIT_STATUS.FINAL,
            SUBMIT_STATUS.FINAL_NOT_OK,
        ].includes(entry.submitStatus);

        return !hasLock || hasBeenSubmitted;
    }
}
